// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"455":"original","596":"sketchy"}[chunkId] + ".style." + {"455":"26bca53c","596":"a71cec46"}[chunkId] + ".css";
};